import _ from 'lodash';
import Text from 'components/base/Text';
import StatefulInfoBox from 'components/StatefulInfoBox';

const TotalSummary = ({ total, isLoading, isError }) => {
  const totalContributorsUI = _.get(total, 'contributors');
  const totalTeamsUI = _.get(total, 'teams');

  return (
    <div data-cy='sync-teams-total-summary'>
      <StatefulInfoBox
        isLoading={isLoading}
        isError={isError}
        data-cy='sync-teams-total-summary'
      >
        <Text>
          <b>{totalTeamsUI} teams</b> and{' '}
          <b>{totalContributorsUI} contributors</b> selected
        </Text>
      </StatefulInfoBox>
    </div>
  );
};

export default TotalSummary;
